module.exports = __webpack_public_path__ + "static/sandwich200-de97bdaf4ba027b1dbe8bb21aec43661.png";